import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    OvertimeGroupDto, OvertimeGroupPaginator,
    CreateOvertimeGroupDto,
    QueryOvertimeGroupDto,
    SearchOvertimeGroupDto,
    UpdateOvertimeGroupDto
} from "../models/overtime-group.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetOvertimeGroup(companyId: number, options?: QueryOvertimeGroupDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.OVERTIMEGROUP.GET;
    const request = (options: QueryOvertimeGroupDto) => API.ProcessingCompanyAPI.getOvertimeGroups(companyId,options);

    const { data, isLoading, error, refetch } = useQuery<OvertimeGroupPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetOvertimeGroupSearch(companyId: number) {

    return useMutation(
        (options?: SearchOvertimeGroupDto) => API.ProcessingCompanyAPI.getOvertimeGroupSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetOvertimeGroupById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.OVERTIMEGROUP.DETAIL;
    const request = API.ProcessingCompanyAPI.getOvertimeGroupById(companyId,id);

    const {data, isLoading, error} = useQuery<{ data:OvertimeGroupDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateOvertimeGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateOvertimeGroupDto}) => API.ProcessingCompanyAPI.createOvertimeGroup(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.OVERTIMEGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateOvertimeGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateOvertimeGroupDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateOvertimeGroup(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.OVERTIMEGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteOvertimeGroup() {

    return useMutation(
        ({companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deleteOvertimeGroupById(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}